const features = {
  ALLOW_COLLAPSING_APP_SIDEBAR: "allow_collapsing_app_sidebar",
  DISPLAY_PAID_ADS: "display_paid_ads",
  ALLOW_ACCESS_TO_PREMIUM_MODELS: "allow_access_to_premium_models",
  MODEL_REQUESTS: "model_requests",
} as const;

export { features };
